// frontend/src/utils/emailDomainRouter.js

export const getEmailDomain = (email) => {
  const safe = (email || "").trim().toLowerCase();
  const at = safe.lastIndexOf("@");
  if (at === -1) return "";
  return safe.slice(at + 1);
};

export const isValidEmail = (email) => {
  const safe = (email || "").trim();
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(safe);
};

// Returns: "GOOGLE" for gmail.com, otherwise "OTP"
export const getAuthMethodByEmailDomain = (email) => {
  const domain = getEmailDomain(email);
  return domain === "gmail.com" ? "GOOGLE" : "OTP";
};
